import { Modal } from "@/shared/modal";
import { FC, useState } from "react";
import { useTranslations } from "use-intl";
import { BpmRolesForm } from "@/modules/bpm/features/save-bpm-role";
import { useBpmRoles } from "@/modules/bpm/widgets/bpm-roles-list/model/use-bpm-roles";
import { BpmRolesListView } from "@/modules/bpm/widgets/bpm-roles-list/ui/bpm-roles-list-view";
import { BpmRolesListItemOptionsProps } from "@/modules/bpm/widgets/bpm-roles-list-item-options";

export function BpmRolesList({
  Options,
}: {
  Options: FC<BpmRolesListItemOptionsProps>;
}) {
  const t = useTranslations("BpmRolesList");
  const [editId, setEditId] = useState<string | null>(null);
  const { loading, records } = useBpmRoles();

  const closeModal = () => setEditId(null);

  return (
    <>
      <BpmRolesListView
        loading={loading}
        dataSource={records}
        setEditId={setEditId}
        Options={Options}
      />
      <Modal
        title={t("Edit role assignment")}
        open={!!editId}
        onCancel={closeModal}
      >
        <BpmRolesForm id={editId as string} afterSubmit={closeModal} />
      </Modal>
    </>
  );
}
